// extracted by mini-css-extract-plugin
export default {"formContent":"index_formContent_O6v8p","title":"index_title_NW9cJ","box":"index_box_bEZRI","formList":"index_formList_uxW5O","bot":"index_bot_kSL8P"};